import { Swiper, Navigation, Autoplay } from 'swiper';

Swiper.use([
    Navigation,
    Autoplay,
]);

$(function() {
    let swiper = new Swiper('.relatednews__swiper--half', {
        spaceBetween: $('.relatednews__swiper--half').data('spaceBetween'),
        slidesPerView: 1,
        navigation: {
            nextEl: `.relatednews__swiper--half .cappendijk__swiper__controls__next`,
            prevEl: `.relatednews__swiper--half .cappendijk__swiper__controls__prev`,
        },
        autoplay: {
            delay: 7500,
        },
        breakpoints: {
            993: {
                slidesPerView: 1,
                slidesPerColumn: 3,
                slidesPerColumnFill: 'row',
            },
            0: {
                slidesPerView: 1.1,
                slidesPerColumn: 1,
                slidesPerColumnFill: 'column',
            },
        },
    });
    $(window).on('resize', function () {
        if (swiper.initialized) {
            swiper.update();
        }
    });

    let related = new Swiper('.relatednews__swiper--full', {
        spaceBetween: $('.relatednews__swiper--full').data('spaceBetween'),
        slidesPerView: 1.1,
        navigation: {
            nextEl: `.relatednews__swiper--full .cappendijk__swiper__controls__next`,
            prevEl: `.relatednews__swiper--full .cappendijk__swiper__controls__prev`,
        },
        breakpoints: {
            1200: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
        },
    });
    $(window).on('resize', function () {
        if (related.initialized) {
            related.update();
        }
    });
});
